import { render, staticRenderFns } from "./performance-widget.vue?vue&type=template&id=432061c0"
import script from "./performance-widget.vue?vue&type=script&lang=js"
export * from "./performance-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports